<!-- 已结束 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('报装编号')">
              <a-input :placeholder="$t('请输入报装编号')" v-model="queryParam.installationNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <TaskActHistoricDetailBtn :data-id="record.ticketsId"></TaskActHistoricDetailBtn>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>

    <construction-detail-modal ref="modalForm" @ok="modalFormOk"></construction-detail-modal>
    <Examine ref="ExamineForm" @ok="modalFormOk"></Examine>
    <SurveyInformation ref="SurveyInformationForm" @ok="modalFormOk"></SurveyInformation>
    <Drawing ref="DrawingForm" @ok="modalFormOk"></Drawing>
    <LeaderApproval ref="LeaderApprovalForm" @ok="modalFormOk"></LeaderApproval>
    <EnterContract ref="EnterContractForm" @ok="modalFormOk"></EnterContract>
    <FinancialConfirmation ref="FinancialConfirmationForm" @ok="modalFormOk"></FinancialConfirmation>
    <LeaderDispatch ref="LeaderDispatchForm" @ok="modalFormOk"></LeaderDispatch>
    <EnterConstruction ref="EnterConstructionForm" @ok="modalFormOk"></EnterConstruction>
    <EngineeringAcceptance ref="EngineeringAcceptanceForm" @ok="modalFormOk"></EngineeringAcceptance>
    <putOnRecord ref="putOnRecordForm" @ok="modalFormOk"></putOnRecord>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ConstructionDetailModal from './modules/apply/ConstructionDetailModal'
  import TaskActHistoricDetailBtn from './modules/flowable/TaskActHistoricDetailBtn.vue'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import Examine from './modules/examine/ConstructionDetailModal'//工程部审核、审核
  import SurveyInformation from './modules/surveyInformation/ConstructionDetailModal'//录入勘测信息
  import Drawing from './modules/drawing/ConstructionDetailModal'//录入图纸和预算
  import LeaderApproval from './modules/leaderApproval/ConstructionDetailModal'//审批图纸和预算、审批合同
  import EnterContract from './modules/enterContract/ConstructionDetailModal'//录入合同
  import FinancialConfirmation from './modules/financialConfirmation/ConstructionDetailModal'//财务确认
  import LeaderDispatch from './modules/leaderDispatch/ConstructionDetailModal'//领导审批派单
  import EnterConstruction from './modules/enterConstruction/ConstructionDetailModal'//录入施工文件
  import EngineeringAcceptance from './modules/engineeringAcceptance/ConstructionDetailModal'//工程验收
  import putOnRecord from '@/views/workOrderManagement/workManagement/modules/putOnRecord'//建档
  import { postAction } from '@/api/manage'

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ConstructionDetailModal,
      TaskActHistoricDetailBtn,
      Examine,
      SurveyInformation,
      Drawing,
      LeaderApproval,
      EnterContract,
      FinancialConfirmation,
      LeaderDispatch,
      EnterConstruction,
      EngineeringAcceptance,
      putOnRecord
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/engineering/installationDetail/list",
          delete: "/jeecg-engineering/engineering/installationDetail/delete",
          deleteBatch: "/jeecg-engineering/engineering/installationDetail/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          start: '/jeecg-engineering/engineering/installationDetail/startProcess/engineering',
          
        },
        dictOptions:{},
        superFieldList:[],
        queryParam: {
          workState: -1
        }
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      description() {
        return this.$t('construction_detail管理页面')
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title:this.$t('报装编号'),
            align:"center",
            dataIndex: 'installationNum'
          },
          {
            title:this.$t('名称'),
            align:"center",
            dataIndex: 'clientName'
          },
          {
            title:this.$t('报装类型'),
            align:"center",
            dataIndex: 'installationType',
            customRender: (text) => {
             return filterDictTextByCache('installationType', text)
             }
          },
          {
            title:this.$t('报装状态'),
            align:"center",
            dataIndex: 'installationState',
            customRender: (text) => {
             return filterDictTextByCache('installationState', text)
             }
          },
          {
            title:this.$t('当前任务'),
            align:"center",
            dataIndex: 'currentNode',
            customRender: (text) => {
             return filterDictTextByCache('currentNode', text)
             }
          },
          {
            title:this.$t('申请时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title:this.$t('历时'),
            align:"center",
            dataIndex: 'diachronic'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'installationId',text:'报装id'})
        fieldList.push({type:'string',value:'companyId',text:'公司id'})
        fieldList.push({type:'int',value:'isAcceptance',text:'是否需要验收'})
        fieldList.push({type:'string',value:'projectDetail',text:'项目说明'})
        fieldList.push({type:'int',value:'isDesignChanges',text:'是否存在设计变更'})
        fieldList.push({type:'string',value:'constructionRemark',text:'施工备注'})
        fieldList.push({type:'string',value:'constructionAnnex',text:'施工附件'})
        fieldList.push({type:'string',value:'acceptanceAnnex',text:'验收附件'})
        fieldList.push({type:'string',value:'remark',text:'备注信息'})
        this.superFieldList = fieldList
      },
      // 处理
      handleNodes(row){
        this.$nextTick(()=>{
          if(row.currentNode == 2){//受理
            this.$refs.ExamineForm.edit(row,false);
          }else if(row.currentNode == 3){//勘察设计
            this.$refs.SurveyInformationForm.edit(row,false);
          }else if(row.currentNode == 4){//预算
            this.$refs.DrawingForm.edit(row,false);
          }else if(row.currentNode == 5){//审批
            this.$refs.LeaderApprovalForm.edit(row,false);
          }else if(row.currentNode == 6){//收费
            this.$refs.FinancialConfirmationForm.edit(row,false);
          }else if(row.currentNode == 7){//施工
            this.$refs.EnterConstructionForm.edit(row,false);
          }else if(row.currentNode == 8){//验收
            this.$refs.EngineeringAcceptanceForm.edit(row,false);
          }else if(row.currentNode == 9){//建档
            this.$refs.putOnRecordForm.init(row,false);
          }
        })
      },
      // 审核
      handleAudit(row){
        this.$nextTick(()=>{
          this.$refs.ExamineForm.edit(row);
        })
      },
      // 开启
      handleStart(row){
        this.loading = true;
        postAction(this.url.start,{dataId: row.ticketsId}).then(res=>{
          if(res.success){
            this.$message.success(this.$t('开启成功'));
            this.loading = false;
            this.loadData();
          }else{
            this.$message.error(this.$t('开启失败'));
            this.loading = false;
          }
        });
      },
      modalFormOk(){
        this.loading = true;
        this.loadData();
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>